import React from 'react';
import { Container, Row, Col } from "react-bootstrap";


const Regulation = () => {
    return (
      <Container className="my-5">
      <Row className="justify-content-center">
        <Col md={8} className="text-center text-color-site">   
          <h1 className="display-4">Política de Privacidade</h1>

          <div className="my-4 text-start">
            <p>
                Última atualização: 19 de abril de 2025 
            </p>
            
            <p>
                Obrigado por visitar o website [https://zauso-dev.com.br] ("o Site"). Respeitamos a sua privacidade e estamos comprometidos em proteger as informações pessoais que você possa fornecer enquanto navega em nosso site. 
                Esta Política de Privacidade descreve como coletamos, usamos, compartilhamos e protegemos as suas informações pessoais.
            </p>
            
            <h1 className="display-4">Opções do Usuário</h1>
            <p>
                Não realizamos marketing direto nem enviamos boletins informativos por e-mail. 
                Os usuários que optarem por receber comunicações podem fazê-lo por meio da página específica para essa finalidade.
            </p>
        
            <h1 className="display-4">Cookies</h1>
            <p>
                Utilizamos cookies para melhorar a experiência do usuário e personalizar o conteúdo oferecido. 
                Os cookies podem ser desativados nas configurações do navegador, mas isso pode afetar o funcionamento adequado do site.
            </p>
          </div>
          </Col>  
       </Row>
    </Container>
    )
}
export default Regulation;